import { finalize } from 'rxjs/operators';
import { CookieService } from 'ngx-cookie-service';
// Services
import { QuickflowsService } from 'QuickflowsApp/ts/services/quickflows.service';
// Constants
import { QUICKFLOWS_SINGLE_SECURITY_COOKIE_NAME } from 'QuickflowsApp/ts/constants';
// Components
import { IconSearchAutocompleteComponent } from 'SearchApp/ts/features/icon-search-autocomplete/icon-search-autocomplete.component';
import * as i0 from "@angular/core";
import * as i1 from "ngx-cookie-service";
import * as i2 from "QuickflowsApp/ts/services/quickflows.service";
import * as i3 from "@angular/common";
import * as i4 from "../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i5 from "../../../../../../../search/static/search/ts/features/icon-search-autocomplete/icon-search-autocomplete.component";
import * as i6 from "../../../../../../../../ycharts/static/ts/features/directives/popovers/tooltip/tooltip.directive";
const _c0 = () => ["popover"];
function SingleSelectQuickflowsComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 6)(1, "div", 7)(2, "a", 8);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 9);
    i0.ɵɵlistener("click", function SingleSelectQuickflowsComponent_div_3_Template_div_click_4_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.deleteItem()); });
    i0.ɵɵelementStart(5, "span");
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(6, "svg", 10);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("tooltipPlacement", "left")("tooltipTitle", ctx_r1.currentSecurity.securityName);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("href", ctx_r1.currentSecurity.securityUrl, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.currentSecurity.displaySecurityId, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("name", "icon-close-circle");
} }
function SingleSelectQuickflowsComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 0)(1, "div", 11)(2, "span");
    i0.ɵɵtext(3, "Search for a security");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span");
    i0.ɵɵtext(5, "to view Quickflows");
    i0.ɵɵelementEnd()()();
} }
function SingleSelectQuickflowsComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 0)(1, "div", 11)(2, "span");
    i0.ɵɵtext(3, "There are no quickflows available for");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span");
    i0.ɵɵtext(5, "the current selected security");
    i0.ɵɵelementEnd()()();
} }
function SingleSelectQuickflowsComponent_ng_container_6_div_1_div_1_div_3_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const quickflow_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("tooltipClasses", i0.ɵɵpureFunction0(3, _c0))("tooltipTitle", quickflow_r4["tooltip_text"]);
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-info");
} }
function SingleSelectQuickflowsComponent_ng_container_6_div_1_div_1_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "a", 16)(2, "span", 17);
    i0.ɵɵlistener("click", function SingleSelectQuickflowsComponent_ng_container_6_div_1_div_1_div_3_Template_span_click_2_listener() { const quickflow_r4 = i0.ɵɵrestoreView(_r3).$implicit; const ctx_r1 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r1.select(quickflow_r4["id"])); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, SingleSelectQuickflowsComponent_ng_container_6_div_1_div_1_div_3_div_3_Template, 2, 4, "div", 18);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const quickflow_r4 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("textContent", quickflow_r4["label"]);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", quickflow_r4["tooltip_text"]);
} }
function SingleSelectQuickflowsComponent_ng_container_6_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "div", 14);
    i0.ɵɵelementStart(2, "div", 15);
    i0.ɵɵtemplate(3, SingleSelectQuickflowsComponent_ng_container_6_div_1_div_1_div_3_Template, 4, 2, "div", 13);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const quickflowObj_r5 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("textContent", quickflowObj_r5.key);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", quickflowObj_r5.value);
} }
function SingleSelectQuickflowsComponent_ng_container_6_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 0);
    i0.ɵɵtemplate(1, SingleSelectQuickflowsComponent_ng_container_6_div_1_div_1_Template, 4, 2, "div", 13);
    i0.ɵɵpipe(2, "keyvalue");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const quickflowsGroupedByCategory_r6 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(2, 1, quickflowsGroupedByCategory_r6));
} }
function SingleSelectQuickflowsComponent_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, SingleSelectQuickflowsComponent_ng_container_6_div_1_Template, 3, 3, "div", 12);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.availableQuickflows);
} }
function SingleSelectQuickflowsComponent_ng_container_7_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 0)(1, "div", 20);
    i0.ɵɵelement(2, "div", 21)(3, "div", 22)(4, "div", 23)(5, "div", 24);
    i0.ɵɵelementEnd()();
} }
function SingleSelectQuickflowsComponent_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, SingleSelectQuickflowsComponent_ng_container_7_div_1_Template, 6, 0, "div", 12);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.availableQuickflows);
} }
/**
 *
 * Single Select Quickflows Component
 *
 * This component is one tab of the quickflows menu.
 *
 * Input Properties:
 *   displaySecurityId: The display security ID to initialize this component with, e.g. VTSAX
 *   securityId: The security ID to initialize this component with, e.g. M:VTSAX
 *
 */
export class SingleSelectQuickflowsComponent {
    constructor(cookieService, quickflowsService) {
        this.cookieService = cookieService;
        this.quickflowsService = quickflowsService;
        this.availableQuickflows = [];
        this.currentSecurity = null;
        this.loadingCollection = false;
    }
    ngOnInit() {
        // autocompleter uses `search_id` which is essentially a security's `security_id`
        if (this.securityId && this.displaySecurityId && this.securityName && this.securityUrl) {
            this.addItem({
                search_id: this.securityId,
                display_security_id: this.displaySecurityId,
                name: this.securityName,
                url: this.securityUrl,
            });
        }
        else {
            const cookie = this.cookieService.get(QUICKFLOWS_SINGLE_SECURITY_COOKIE_NAME) || '""';
            const security = JSON.parse(decodeURIComponent(cookie));
            // special case for when hover feature is first launched; cookies not storing `securityName`
            // will have `name` set to an empty string
            let securityName = '';
            if (security.securityName) {
                // eslint-disable-next-line prefer-destructuring
                securityName = security.securityName;
            }
            // special case for when hover feature is first launched; cookies not storing `securityUrl`
            // will have `url` set to the current URL
            let securityUrl = window.location.pathname;
            if (security.securityUrl) {
                // eslint-disable-next-line prefer-destructuring
                securityUrl = security.securityUrl;
            }
            if (security && Object.keys(security).length > 0) {
                this.addItem({
                    search_id: security.securityId,
                    display_security_id: security.displaySecurityId,
                    name: securityName,
                    url: securityUrl,
                });
            }
        }
    }
    select(quickflowId) {
        this.quickflowRedirect(quickflowId);
    }
    quickflowRedirect(quickflowId) {
        if (!this.currentSecurity) {
            return;
        }
        this.quickflowsService
            .getSingleSecurityQuickflowsRedirect(quickflowId, this.currentSecurity.securityId)
            .subscribe((data) => {
            const quickflowURL = new URL(data.url);
            // Change the browser URL to the quickflows URL.
            window.location.assign(quickflowURL.href);
            // If the path of the application is not changing we need to set the
            // url state and reload so that the application loads from scratch.
            if (quickflowURL.pathname === window.location.pathname) {
                window.location.reload();
            }
        });
    }
    addItem(object) {
        // autocompleter uses `search_id` which is essentially a security's `security_id`
        this.currentSecurity = {
            displaySecurityId: object.display_security_id,
            securityId: object.search_id,
            securityName: object.name,
            securityUrl: object.url,
        };
        this.cookieService.set(QUICKFLOWS_SINGLE_SECURITY_COOKIE_NAME, encodeURIComponent(JSON.stringify(this.currentSecurity)), {
            path: '/',
        });
        this.updateQuickflowCollection();
        this.focusAutocompleter();
    }
    deleteItem() {
        this.availableQuickflows = [];
        this.currentSecurity = null;
        this.cookieService.set(QUICKFLOWS_SINGLE_SECURITY_COOKIE_NAME, '', { path: '/' });
        this.focusAutocompleter();
    }
    updateQuickflowCollection() {
        if (!this.currentSecurity) {
            return;
        }
        this.loadingCollection = true;
        // fetch all single security quickflows
        this.quickflowsService
            .getSingleSecurityQuickflowsCollection(this.currentSecurity.securityId)
            .pipe(finalize(() => {
            this.loadingCollection = false;
        }))
            .subscribe({
            next: (data) => {
                this.availableQuickflows = data.filter((quickflowCategory) => {
                    const categoryName = Object.keys(quickflowCategory)[0];
                    return quickflowCategory[categoryName].length > 0;
                });
            },
            error: () => {
                this.availableQuickflows = [];
            },
        });
    }
    focusAutocompleter() {
        if (this.autocompleteComponent) {
            this.autocompleteComponent.focus();
        }
    }
}
SingleSelectQuickflowsComponent.ɵfac = function SingleSelectQuickflowsComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SingleSelectQuickflowsComponent)(i0.ɵɵdirectiveInject(i1.CookieService), i0.ɵɵdirectiveInject(i2.QuickflowsService)); };
SingleSelectQuickflowsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SingleSelectQuickflowsComponent, selectors: [["ycn-single-select-quickflows"]], viewQuery: function SingleSelectQuickflowsComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(IconSearchAutocompleteComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.autocompleteComponent = _t.first);
    } }, inputs: { displaySecurityId: "displaySecurityId", securityId: "securityId", securityName: "securityName", securityUrl: "securityUrl" }, standalone: false, decls: 8, vars: 7, consts: [[1, "quickflows-section"], [1, "quickflows-section-header"], [3, "submitHandler", "appendToBody", "searchType"], ["class", "quickflows-labels-list", 4, "ngIf"], ["class", "quickflows-section", 4, "ngIf"], [4, "ngIf"], [1, "quickflows-labels-list"], ["ycnTooltip", "", 1, "btn", "btn-purple-tint", 3, "tooltipPlacement", "tooltipTitle"], [3, "href"], [1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-close", 3, "click"], ["ycnIcon", "", 3, "name"], [1, "get-started-small"], ["class", "quickflows-section", 4, "ngFor", "ngForOf"], [4, "ngFor", "ngForOf"], [1, "quickflows-section-title", 3, "textContent"], [1, "quickflows-list"], ["href", "javascript:void(0)", 1, "quickflows-list-item"], [3, "click", "textContent"], ["class", "btn btn-xs btn-circle btn-transparent btn-i", "ycnTooltip", "", 3, "tooltipClasses", "tooltipTitle", 4, "ngIf"], ["ycnTooltip", "", 1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-i", 3, "tooltipClasses", "tooltipTitle"], [1, "quickflows-list", "options-list-skeleton"], [1, "skeleton", 2, "width", "88%"], [1, "skeleton", 2, "width", "40%"], [1, "skeleton", 2, "width", "15%"], [1, "skeleton", 2, "width", "65%"]], template: function SingleSelectQuickflowsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "ycn-icon-search-autocomplete", 2);
        i0.ɵɵlistener("submitHandler", function SingleSelectQuickflowsComponent_Template_ycn_icon_search_autocomplete_submitHandler_2_listener($event) { return ctx.addItem($event); });
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(3, SingleSelectQuickflowsComponent_div_3_Template, 7, 5, "div", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, SingleSelectQuickflowsComponent_div_4_Template, 6, 0, "div", 4)(5, SingleSelectQuickflowsComponent_div_5_Template, 6, 0, "div", 4)(6, SingleSelectQuickflowsComponent_ng_container_6_Template, 2, 1, "ng-container", 5)(7, SingleSelectQuickflowsComponent_ng_container_7_Template, 2, 1, "ng-container", 5);
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("appendToBody", true)("searchType", "quickflow_securities");
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.currentSecurity);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.currentSecurity && !ctx.loadingCollection);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.currentSecurity && ctx.availableQuickflows.length == 0 && !ctx.loadingCollection);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.currentSecurity && !ctx.loadingCollection);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.loadingCollection);
    } }, dependencies: [i3.NgForOf, i3.NgIf, i4.IconDirective, i5.IconSearchAutocompleteComponent, i6.TooltipDirective, i3.KeyValuePipe], encapsulation: 2 });
